module.exports = __webpack_public_path__ + "ffcbef15d60d19210bf0cdd76098e51d.svg";